import { detectIpad, detectMobile } from '../utils/deviceDetect'
import { apiEndPointGenarator, getApiUrl, getBetApiUrl } from './env'

export const APP_NAME = 'rod25' //@TODO: made as default
export const BASE_SITE_NAMES = {
    dev: 'bet25dev.dk',
    test: 'bet25test.dk',
    prod: 'bet25.dk',
}

export const CMS_PATH = apiEndPointGenarator(
    `https://cms.${BASE_SITE_NAMES.dev}`,
    `https://cms.${BASE_SITE_NAMES.test}`,
    `https://cms.${BASE_SITE_NAMES.prod}`
)

export const IMG_PATH =
    CMS_PATH + '/upload/files/rod25/images/uploads/roed25/img/live-casino/'

export const getPlatformForApi = () =>
    !detectMobile() || detectIpad() ? 'web' : 'mobile'

export const API_URL = `${getApiUrl()}/v2/`
export const GAME_LAUNCH_API = `${getApiUrl()}/games/`
export const MAIN_REST_BASE_API = `${getBetApiUrl()}rod25/api.php`
export const CONTENT_API_BASE_URL = `${getBetApiUrl()}`
export const CDN_IMG_PATH = apiEndPointGenarator(
    `https://cdn.${BASE_SITE_NAMES.dev}/casino/img/thumbs/`,
    `https://cdn.${BASE_SITE_NAMES.prod}/casino/img/thumbs/`,
    `https://cdn.${BASE_SITE_NAMES.prod}/casino/img/thumbs/`
)
